import {
  Tooltip as TooltipUI,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "./tooltip";
import { cn } from "./utils";

export default function Tooltip({ label, children, className, ...props }) {
  if (!label) return children;

  return (

    <TooltipProvider>
      <TooltipUI>
        <TooltipTrigger asChild>
          <div>{children}</div>
        </TooltipTrigger>
        <TooltipContent side="bottom" {...props} className={cn(className)}>
          <p>{label}</p>
        </TooltipContent>
      </TooltipUI>
    </TooltipProvider>
  );
}
